export default "__VITE_ASSET__D37fd3ME__"